<template>
  <div class="global-skeleton ahc-main__content">
    <!-- Breadcrumb -->
    <div class="global-skeleton__breadcrumb">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Title -->
    <div class="global-skeleton__title">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Subtitle -->
    <div class="global-skeleton__subtitle">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Cards -->
    <div class="global-skeleton__cards">
      <div class="global-skeleton__card">
        <span class="global-skeleton__anim-text" />
      </div>
      <div class="global-skeleton__card">
        <span class="global-skeleton__anim-text" />
      </div>
    </div>
    <!-- Section -->
    <div class="global-skeleton__section">
      <div class="global-skeleton__section-title">
        <span class="global-skeleton__anim-text" />
        <span class="global-skeleton__anim-text" />
      </div>
      <div class="global-skeleton__section-content">
        <!-- List -->
        <div class="global-skeleton__list">
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.global-skeleton {
  position: relative;
  background-color: ccf.$color-neutral-10;

  div {
    position: relative;
  }

  span {
    display: block;
  }

  &__breadcrumb {
    padding: ccf.$spacing-inner-03 0 ccf.$spacing-inner-04;

    @include ccf.breakpoint('large+') {
      display: none;
    }

    span {
      max-width: 100px;
      height: 20px;
    }
  }

  &__title {
    span {
      margin-bottom: ccf.$spacing-outer-02;
      height: 36px;
      width: 80%;

      @include ccf.breakpoint('large+') {
        width: 30%;
      }
    }
  }

  &__subtitle {
    span {
      margin-bottom: ccf.$spacing-outer-01;
      height: 24px;
      width: 50%;

      @include ccf.breakpoint('large+') {
        width: 15%;
      }
    }
  }

  &__cards {
    display: flex;
    flex-direction: column;
    gap: ccf.$spacing-outer-02;

    @include ccf.breakpoint('large+') {
      flex-direction: row;
    }
  }

  &__card {
    width: 100%;

    span {
      height: 200px;
      margin-bottom: ccf.$spacing-outer-01;
    }
  }

  &__section {
    border-top: 1px solid ccf.$color-neutral-20;
    margin-bottom: ccf.$spacing-outer-05;
    padding-top: ccf.$spacing-inner-04;
    align-items: flex-start;
    justify-content: flex-start;
    display: block;
    width: 100%;
    gap: ccf.$spacing-outer-02;

    @include ccf.breakpoint('large+') {
      display: flex;
    }
  }

  &__section-title {
    width: 100%;

    @include ccf.breakpoint('large+') {
      width: 60%;
    }

    span {
      &:nth-child(1) {
        width: 100%;
        height: 60px;
        margin-bottom: ccf.$spacing-inner-03;
      }

      &:nth-child(2) {
        width: 100%;
        height: 265px;
        margin-bottom: ccf.$spacing-outer-02;
      }
    }
  }

  &__section-content {
    width: 100%;
    padding-left: 0;

    @include ccf.breakpoint('large+') {
      width: 60%;
    }
  }

  &__list {
    position: relative;
    border: 1px solid ccf.$color-neutral-20;
    border-radius: ccf.$border-radius;
    display: block;
    width: 100%;

    &-item {
      position: relative;
      padding: 25px 25px 31px 105px;
      border-bottom: 1px solid ccf.$color-neutral-20;

      span {
        &:nth-child(1) {
          position: absolute;
          left: 25px;
          top: 25px;
          width: 56px;
          height: 56px;
        }

        &:nth-child(2) {
          width: 70%;
          max-width: 211px;
          height: 22px;
          margin-bottom: ccf.$spacing-inner-03;
        }

        &:nth-child(3) {
          width: 55%;
          max-width: 160px;
          height: 22px;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  &__anim-text {
    will-change: transform;
    background: linear-gradient(
      75deg,
      ccf.$color-neutral-20 15%,
      ccf.$color-neutral-30 25%,
      ccf.$color-neutral-20 45%
    );
    background-size: 800px 400px;
  }

  &__anim-text {
    animation: placeHolderShimmer 4.5s linear infinite forwards;
  }
}

@keyframes placeHolderShimmer {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: -800px 0;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: 800px 0;
  }
}
</style>
